import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * AuthNavigationService centralizes the post-login redirect so the password
 * login path and the MFA verify path navigate identically and cannot drift.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthNavigationService {
  constructor(
    private _authService: AuthService,
    private _router: Router
  ) {}

  /** Navigate to the landing page appropriate for the logged-in user's role. */
  navigateAfterLogin() {
    if (!this._authService.hasToken()) {
      return;
    }
    switch (this._authService.role) {
      case 'Admin':
      case 'Client':
      case 'Customer':
      case 'Operator':
        this._router.navigate(['/overview']);
        break;
    }
  }
}
